import React, { useState } from "react";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const reviews = [
  {
    name: "Sarah K.",
    role: "Home Brewer, Kigali",
    quote:
      "Bright citrus with a chocolate finish—this is the most consistent specialty cup I’ve had in Rwanda.",
    photo: "/Coffee15.jpg",
  },
  {
    name: "David M.",
    role: "Café Owner",
    quote:
      "Our guests notice the difference. Fresh roast, clean wash process, and a story worth sharing.",
    photo: "/Coffee17.jpg",
  },
  {
    name: "Jean Paul",
    role: "Wholesale Partner",
    quote:
      "Bold and balanced. Reliable supply and beautiful packaging that matches the quality in the cup.",
    photo: "/Coffee18.jpg",
  },
];

const Testimonials = () => {
  const [start, setStart] = useState(0);
  const visible = [
    reviews[start % reviews.length],
    reviews[(start + 1) % reviews.length],
    reviews[(start + 2) % reviews.length],
  ];

  return (
    <section className="bg-espresso px-5 py-16 text-cream md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:gap-10">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
                Loved by Coffee Lovers
              </p>
              <h2 className="mt-3 font-display text-3xl md:text-4xl">
                Real People, Real Reviews
              </h2>
            </div>
            <div className="rounded-2xl border border-cream/15 bg-[#3A2820] px-6 py-4">
              <div className="flex gap-1 text-gold">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <p className="mt-2 font-display text-4xl">4.9</p>
              <p className="text-sm text-cream/65">Based on 486 reviews</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <Link to="/contact" className="text-sm text-gold underline-offset-4 hover:underline">
              See all reviews
            </Link>
            <div className="flex gap-2">
              <button
                type="button"
                aria-label="Previous reviews"
                onClick={() => setStart((s) => (s - 1 + reviews.length) % reviews.length)}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/30 transition hover:bg-cream/10"
              >
                <FaChevronLeft />
              </button>
              <button
                type="button"
                aria-label="Next reviews"
                onClick={() => setStart((s) => (s + 1) % reviews.length)}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/30 transition hover:bg-cream/10"
              >
                <FaChevronRight />
              </button>
            </div>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {visible.map((review) => (
            <article
              key={`${review.name}-${start}`}
              className="rounded-2xl border border-cream/10 bg-[#3A2820] p-6"
            >
              <div className="mb-4 flex gap-1 text-gold">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className="text-sm" />
                ))}
              </div>
              <p className="min-h-[6rem] text-base leading-relaxed text-cream/90">
                “{review.quote}”
              </p>
              <div className="mt-6 flex items-center gap-3">
                <img
                  src={review.photo}
                  alt=""
                  className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/40"
                />
                <div>
                  <p className="font-semibold">{review.name}</p>
                  <p className="text-xs text-cream/60">{review.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
